export const TOOL_TASK = 'update-mfa-settings';
export const TOOL_TITLE = 'Update Multi-Factor Authentication';
export const TOOL_STACK_OVERFLOW_MESSAGE = 'Please try again once updating the users\' MFA settings finishes';
export const FILE_NAME = 'Update-mfa-settings-report';
export const LEGACY_FILE_HEADERS = {
    userId: 'User Id',
    email: 'Email',
    oldStatus: 'Old Status',
    newStatus: 'New Status',
    actionStatus: 'Action Status',
};
export const FILE_HEADERS = {
    userId: 'User Id',
    email: 'Email',
    oldStatus: 'Old MFA Status',
    newStatus: 'New MFA Status',
    oldEmailPrimaryFactorStatus: 'Old Email MFA Status',
    newEmailPrimaryFactorStatus: 'New Email MFA Status',
    actionStatus: 'Action Status',
};

export const TOOL_PROGRESS_LABEL = 'Bulk Multi-Factor Authentication updating progress...';

export const MFA_SETTINGS_MODAL_TITLES = {
    ENABLE_MFA_SETTINGS: 'Enable Multi-Factor Authentication',
    DISABLE_MFA_SETTINGS: 'Disable Multi-Factor Authentication',
};

export const MODAL_WIDTH = 500;
